import { defaultFeatureFlags, featureFlags, } from 'utils/featureFlagging/featureFlags';
/**
 * Returns the state of a given feature flag.
 *
 * @param state The app state.
 * @param name The name of the feature flag to check against.
 */
export function hasFeature(rootStateOrFlags, name) {
    var _a, _b, _c;
    // Leave rootState for backwards compatibility and allow to provide feature flags directly
    const stateFeatureFlags = (_b = (_a = rootStateOrFlags === null || rootStateOrFlags === void 0 ? void 0 : rootStateOrFlags['settings']) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.featureflags;
    const flags = stateFeatureFlags !== null && stateFeatureFlags !== void 0 ? stateFeatureFlags : rootStateOrFlags;
    const defaultValue = defaultFeatureFlags[name];
    if (flags && name in flags) {
        featureFlags.track([name]);
        return (_c = flags[name]) !== null && _c !== void 0 ? _c : defaultValue;
    }
    // Handles the case where LaunchDarkly works as expected,
    // but a flag referenced in code doesn't exist in LaunchDarkly.
    return defaultValue;
}
